import { createSlice } from "@reduxjs/toolkit";
import { initialApiState } from "../common";
import initialState from "./initialState";
import { fetchAllDials } from "./thunks";

const dialerSlice = createSlice({
  name: "dialerSlice",
  initialState,
  reducers: {
    addCompletedDialToSync: (state, action) => {
      if (action.payload && !state.dialsToSync.includes(action.payload))
        state.dialsToSync = state.dialsToSync?.concat(action.payload);
    },
    clearDialsToSync: (state, _action) => {
      state.dialsToSync = [];
    },
    setDialsToDelete: (state, action) => {
      state.dialsToDelete = action.payload;
    },
    clearDialsToDelete: (state, _action) => {
      state.dialsToDelete = [];
    },
    addDialToList: (state, action) => {
      if (action.payload)
        state.dials.data = state.dials.data.concat(action.payload);
    },
    setDialsLastSyncDate: (state, action) => {
      state.lastSync = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAllDials.pending, (state, _action) => {
      state.dials.state = "pending";
      state.dials.error = null;
    });
    builder.addCase(fetchAllDials.fulfilled, (state, action) => {
      state.dials.state = "success";
      state.dials.data = action.payload;
      state.dials.error = null;
    });
    builder.addCase(fetchAllDials.rejected, (state, action) => {
      state.dials.state = "failed";
      state.dials.data = null;
      state.dials.error = action.error;
    });
    builder.addCase("common/cleanup", (state, _action) => {
      state.dials = initialApiState;
      state.dialsToSync = [];
      state.dialsToDelete = [];
    });
  },
});

export const {
  addCompletedDialToSync,
  addDialToList,
  setDailyDialsToDelete,
  clearDialsToDelete,
  clearDialsToSync,
  setDialsLastSyncDate,
} = dialerSlice.actions;
export default dialerSlice.reducer;
